import { createRouter, createWebHistory } from 'vue-router'
import SignIn from './views/SignIn.vue'
import SignUp from './views/SignUp.vue'
import DocsEnglish from './views/DocsEnglish.vue'
import DocsSpanish from './views/DocsSpanish.vue'
import Home from './views/Home.vue'
import ChatRecom from './views/ChatRecom.vue'
import Profile from './views/Profile.vue'
import SessionService from './service/session.js'
import { local } from './util.js'
const routes = [
    {path: '/',           component: SignIn,        meta: { stage: 'public' }},
    {path: '/signup',     component: SignUp,        meta: { stage: 'signup' }},
    {path: '/home',       component: Home,          meta: { stage: 'signin' }},
    {path: '/chat_recom', component: ChatRecom,     meta: { stage: 'signin' }},
    {path: '/profile',    component: Profile,       meta: { stage: 'signin' }},
    {path: '/docs/en',    component: DocsEnglish,   meta: { stage: 'public' }},
    {path: '/docs/es',    component: DocsSpanish,   meta: { stage: 'public' }}
]
const router = createRouter({
    history: createWebHistory(),
    routes
})
const sessionSvc = new SessionService()

router.beforeEach(async (to, _from, next) => {
    if(local){
        return next()
    }
    let need = to.meta.stage
    if(need === "public"){
        return next()
    }
    let res = await sessionSvc.validateSession()
    if(res.error){
        return next({path: '/'})
    }
    let stage = res.data
    if(need === stage){
        return next()
    }
    if (need === 'signup' && stage === 'signin') {
        return next('/home')
    }
    if (need === 'signin' && stage === 'signup') {
        return next('/signup')
    }
    return next('/')
})
export default router
